
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestOfferResults",
      function () {
        return require("private-next-pages/bestOfferResults.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestOfferResults"])
      });
    }
  